import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { CurrentProductService } from '@spartacus/storefront';
import { filter, takeUntil } from 'rxjs/operators';
import {
  BrandsEnum,
  BrandThemesEnum, IComponentWrapper,
  PositionEnum,
  SdComponentWrapperComponent,
  SizesEnum,
  ThemesEnum
} from '@seb/web-design-system/core';
import { BaseFaqComponent } from '@seb/web-common/core/components/base/base-faq/base-faq.component';
import { FaqEntry, PdpConfig } from '@seb/web-common/core/models';
import { PdpTypeEnum } from '@seb/web-common/core/enums';
import { BrandCornerMapper, HeadingParagraphMapper } from '@seb/web-common/core/mappers';

@Component({
  selector: 'wc-product-faqs',
  templateUrl: './product-faqs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdComponentWrapperComponent, BaseFaqComponent]
})
export class ProductFaqsComponent implements OnInit, OnDestroy {
  themesEnum = ThemesEnum;
  positionEnum = PositionEnum;
  faqs: FaqEntry[];
  wrapperContent: IComponentWrapper;
  lameConfig: PdpConfig;

  @Input() pdpType: any;

  @Input() brand = BrandsEnum.default;

  @Output() hasLoaded = new EventEmitter<void>();

  private readonly destroy$: Subject<void> = new Subject();
  constructor(
    private currentProductService: CurrentProductService,
    @Inject(PLATFORM_ID) protected platformId: any,
    private translateService: TranslateService,
    private cdRef: ChangeDetectorRef,
    private headingParagraphMapper: HeadingParagraphMapper,
    private brandCornerMapper: BrandCornerMapper
  ) {}

  ngOnInit(): void {
    this.lameConfig = this.brandCornerMapper.toWcConfig(this.brand)?.pdp;
    const richParagraphData = {
      heading: {
        headline: this.translateService.instant('pdp.sectionTitles.faq'),
        headlineLevel: 'H2'
      },
      titleLevel: this.pdpType === PdpTypeEnum.ACCESSORY ? 7 : 2,
      textConfig: this.lameConfig?.faqs?.textConfig || PositionEnum.center,
      titleTheme: this.lameConfig?.faqs?.titleTheme || BrandThemesEnum.brand,
      isUnderlined: !!this.lameConfig?.faqs?.titleUnderlined,
      size: SizesEnum.l
    };
    this.wrapperContent = {
      links: [],
      footNotes: [],
      heading: this.headingParagraphMapper.toHeadingParagraph(richParagraphData)
    };
    if (isPlatformBrowser(this.platformId)) {
      this.currentProductService
        .getProduct()
        .pipe(
          filter((p) => p?.faqs?.faqEntries?.length > 0),
          takeUntil(this.destroy$)
        )
        .subscribe((product) => {
          this.faqs = product?.faqs?.faqEntries?.filter((faq) => faq.question);
          this.hasLoaded.emit();
          this.cdRef.markForCheck();
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
